export interface EmailSettings {
    licenseExpiryContacts: string,
    sendFrom: string,
    MailHost: string,
    MailPort: string,
    errorContacts: string
}

export interface IDropItem {
    key: string,
    value: any,
    name: string,
    text: string,
    image: string
}

export interface IField {
    name: string,   
    value: any,
    text?: string | null,
    image:any
}

export enum AuthType {
    None,
    UsernamePassword
}

export interface DropdownOptionNumerical {
    key: number,
    text: string,
    value: number,
}